import Observer from '@/common/scripts/observer';

const observer = new Observer();

class MenuTrigger {
    constructor(buttons) {
        /**
         * Элементы, по которым кликают
         * @type {HTMLElement[]}
         */
        this.buttons = buttons;

        this.openClass = 'is-open';

        /**
         * Состояние кнопки
         * true - открыто
         * false - закрыто
         * @type {Boolean}
         */
        this.isOpen = this.buttons.some((button) => {
            return button.classList.contains(this.openClass);
        });

        this._changeState = this._changeState.bind(this);

        this._bindEvents();
    }

    /**
     * Навешивает слушателей
     * @private
     */
    _bindEvents() {
        this.buttons.forEach((button) => {
            button.addEventListener('click', this._changeState);
        });
    }

    /**
     * Изменяет состояние
     * с отрытого на закрытое и наоборот
     * @param {Event} event - объект события
     * @private
     */
    _changeState(event) {
        this.isOpen = !event.currentTarget.classList.contains(this.openClass);
        const method = this.isOpen ? 'add' : 'remove';

        this.buttons.forEach((button) => {
            button.classList[method](this.openClass);
        });
        this._publishState();
    }

    /**
     * Сообщает о состоянии элемента
     * @private
     */
    _publishState() {
        observer.publish(this.isOpen ? 'menu:openTrigger' : 'menu:closeTrigger');
    }
}

export default MenuTrigger;
